module.exports = __webpack_public_path__ + "img/systems-under-maintenance.79c00761.gif";